import { Component, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LogoComponent } from '../logo/logo.component';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: true,
    imports: [RouterLink, LogoComponent, RouterLinkActive]
})
export class NavigationComponent implements OnInit {
  isMenuOpen = false;
  isScrolled = false;
  isLightMode = false;
  isDropdownOpen = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.checkScroll();
    // Load theme preference on init
    if (isPlatformBrowser(this.platformId)) {
      this.isLightMode = localStorage.getItem('theme') !== 'dark';
      this.applyTheme();
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.checkScroll();
  }

  private checkScroll(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isScrolled = window.scrollY > 20;
    }
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.updateBodyClass();
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.updateBodyClass();
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }


  closeMenuAndDropdown(): void {
    this.isDropdownOpen = false;
    this.closeMenu();
  }

  isDropdownActive(): boolean {
    const currentUrl = this.router.url;
    // Match exact starts or specific routes
    return currentUrl.startsWith('/blog') || currentUrl.startsWith('/faq') || currentUrl.startsWith('/careers');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (isPlatformBrowser(this.platformId)) {
      const target = event.target as HTMLElement;
      if (!target.closest('.dropdown')) {
        this.isDropdownOpen = false;
      }
    }
  }

  toggleTheme(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.isLightMode = !this.isLightMode;
    localStorage.setItem('theme', this.isLightMode ? 'light' : 'dark');
    this.applyTheme();
  }

  private applyTheme(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    if (this.isLightMode) {
      document.body.classList.add('light-mode');
    } else {
      document.body.classList.remove('light-mode');
    }
  }

  private updateBodyClass(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    if (this.isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }
}
